<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="loyaltyItems.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">
        Loyalty Item
        <el-button
          @click="$router.push('/loyaltyItem/create')"
          type="warning"
          icon="el-icon-plus"
          circle
          size="small"
          class="ml-3"
        ></el-button>
      </p>

      <el-col :span="16">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            placeholder="Select"
            @change="
            e => {
              toAnotherPage(page, e), settingTable(page, e);
            }
          "
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="loyaltyItems.data" style="width: 100%">
        <el-table-column type="index" label="No" width="180"></el-table-column>
        <el-table-column sortable prop="name" label="Name" width="180"></el-table-column>
        <el-table-column sortable prop="price" label="Price"></el-table-column>
        <el-table-column sortable prop="imageURL" label="Image"></el-table-column>
        <el-table-column sortable prop="description" label="Description"></el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-edit"
              circle
              @click="$router.push(`/loyaltyItem/edit/${scope.row.id}`)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              circle
              @click="handleDelete(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="loyaltyItems.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toAnotherPage(e, optionView), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      value: false,
      optionsActive: [
        {
          value: true,
          label: "Active"
        },
        {
          value: false,
          label: "No Active"
        }
      ],
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      dialog: false,
      id: null,
      page: 1
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getLoyaltyItem: "loyaltyItem/GetLoyaltyItems",
      deleteLoyaltyItem: "loyaltyItem/DeleteLoyaltyItem",
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    toAnotherPage(page, limit) {
      this.$router.push({ path: "/loyaltyItem", query: { page: page, limit: limit } });
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView
        }
      };
      this.getLoyaltyItem(option);
    }, 
    handleDelete(idx, row) {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
      .then(() => {
        this.deleteLoyaltyItem(row.id);
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
  },
  computed: {
    ...mapState({
      loyaltyItems: state => state.loyaltyItem.loyaltyItems
    })
  },
  watch: {
    loyaltyItems: {
      handler(newValue) {
        if (!newValue.isLoading && !newValue.error) {
          this.dialog = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    let option = {
      params: {
        page: this.page,
        limit: this.optionView
      }
    };
    this.getLoyaltyItem(option);
  }
};
</script>

<style>
.category-title {
  text-align: left;
  font-size: 1.5rem;
}
</style>
